module.exports = __webpack_public_path__ + "media/icons/columns-f9835869.png";